import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
export interface LinkWithTextBodyCellRendererParams {
  url: string;
  testSelector?: string;
  textBody: string;
}

@Component({
    selector: 'app-link-with-text-body-cell-renderer',
    template: `<a [attr.data-test-selector]="testSelector" [href]="url">
    {{ textBody }}
  </a>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkWithTextBodyCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  url!: string;
  testSelector?: string;
  textBody!: string;

  agInit({ url, testSelector, textBody }: CustomParams): void {
    this.url = url;
    this.testSelector = testSelector;
    this.textBody = textBody;
    this.changeDetectorRef.detectChanges();
  }
  refresh(): boolean {
    return false;
  }
}
interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    LinkWithTextBodyCellRendererParams {}
